import React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import Button from '../button'

import { InputLabel, InputProps } from '../input/input'

type FormProps = {
    className?: string
    title?: string
    description?: string
    header?: React.ReactNode
    inputs?: InputProps[]
    button_name?: string
    button_on_tap?: (e?: React.MouseEvent<Element, MouseEvent> | undefined) => any | undefined
}


const Form: React.FunctionComponent<FormProps> = ({ className, title, description, header, inputs, button_name, button_on_tap, children }) => {
    const inputComponents = inputs?.map((p, i) => <InputLabel key={i} {...p} />)

    return (
        <Container className={className}>
            <Title>
                { title }
            </Title>
            <Description>
                { description }
            </Description>
            {
                header
            }
            { inputComponents && <Wrapper>
                { inputComponents }
            </Wrapper>}
            { button_name && <Button onClick={button_on_tap}>{ button_name }</Button> }
            {children}
        </Container>
    )
}

const Container = styled.div`
    display: grid;
    align-items: center;
    justify-items: center;

    width: 100%;
    padding: 0 20px;
    
    background: ${p => p.theme.colors.bg};

    ${up('tablet')} {
        box-shadow: 0px 16px 64px rgba(0, 0, 0, 0.08);
        border-radius: 24px;

        width: 464px;
        padding: 32px;
    }
`

const Title = styled.div`
    text-align: center;
    font-size: 24px;
    line-height: 32px;
    font-weight: bold;
`

const Description = styled.div`
    text-align: center;
    font-size: 14px;
    line-height: 24px;

    margin-top: 8px;
    margin-bottom: 48px;
`

const Wrapper = styled.form`
    display: grid;

    width: 100%;
`

export default Form